import $ from 'jquery'
// import { breakpoints } from './_site';
import { create as initSlider } from './slider'

export const timeout = {}
export const createSlider = $el => {
  var isSingle = $el.is('.content-carousel'),
    options = {
      fade: false,
      centerMode: true,
      centerPadding:0,
      variableWidth: true,
      slidesToShow: 3,
      infinite: true,
      draggable: true,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      touchThreshold:100,
      lazyLoad: 'ondemand',
      autoplay: false,
      responsive: [{
        breakpoint: 1400,
        settings: {
          centerMode: true,
          variableWidth: true,
          slidesToShow: 3
        }
      },
        {
          breakpoint: 1200,
          settings: {
            centerMode: true,
            variableWidth: true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1
          }
        }
      ]
    }

  // if (isSingle) {
  //   options.slidesToShow = 1
  //   options.slidesToScroll = 1
  // }

  initSlider($el, options)
}
export const binds = () => {
  createSlider($('.content-carousel'))
}
